export type DeliveryStatus = 'delivered' | 'hard_bounced' | 'soft_bounced' | 'processing' | 'unknown';

export default function DeliveryStatusBadge({ status, reason }: { status: DeliveryStatus; reason?: string }) {
  const config: Record<DeliveryStatus, { label: string; color: string }> = {
    delivered:     { label: 'Delivered',     color: 'bg-green-100 text-green-700' },
    hard_bounced:  { label: 'Hard Bounced',  color: 'bg-red-100 text-red-700' },
    soft_bounced:  { label: 'Soft Bounced',  color: 'bg-orange-100 text-orange-700' },
    processing:    { label: 'Processing',    color: 'bg-gray-100 text-gray-500' },
    unknown:       { label: '—',             color: 'bg-gray-50 text-gray-400' },
  };
  const { label, color } = config[status] ?? config.unknown;
  return (
    <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${color}`} title={reason || ''}>
      {label}
    </span>
  );
}
